import { render, staticRenderFns } from "./PushMailComposeDialog.vue?vue&type=template&id=1dcf812a&"
import script from "./PushMailComposeDialog.vue?vue&type=script&lang=js&"
export * from "./PushMailComposeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports